import { render, staticRenderFns } from "./CustomerDetail5.vue?vue&type=template&id=67c064e6&scoped=true"
import script from "./CustomerDetail5.vue?vue&type=script&lang=js"
export * from "./CustomerDetail5.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetail5.vue?vue&type=style&index=0&id=67c064e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c064e6",
  null
  
)

export default component.exports